import React from 'react'
import { connect } from 'react-redux'
import { withStyles, Hidden, Paper } from '@material-ui/core'
import FormContent from './FormContent'
import Preview from './Preview'

const PreviewAndFormContent = ({
	classes,
	selectedActionPrediction,
	modal,
}) => (
	<Paper
		className={
			selectedActionPrediction === 'email'
				? modal
					? classes.emailModal
					: classes.email
				: classes.splitFormPreviewPaper
		}
	>
		<Hidden smDown>
			<FormContent modal={modal} />
		</Hidden>
		<Preview modal={modal} />
	</Paper>
)

const styles = (theme) => ({
	email: {
		border: '1px solid #adadad',
		borderRadius: 35,
		// height: '100%',
		overflow: 'hidden',
		[theme.breakpoints.down('sm')]: {
			padding: 0,
			borderRadius: 0,
			border: 'none',
			boxShadow: 'none',
			backgroundColor: 'transparent',
			height: 'calc(100% - 56px)',
		},
	},
	emailModal: {
		border: '1px solid #adadad',
		borderRadius: 35,
		// height: '100%',
		overflow: 'hidden',
		[theme.breakpoints.down('sm')]: {
			padding: 0,
			borderRadius: 0,
			border: 'none',
			boxShadow: 'none',
			backgroundColor: 'transparent',
			height: 'calc(100% - 110px)',
		},
	},
	splitFormPreviewPaper: {
		border: '1px solid #adadad',
		padding: 20,
		borderRadius: 35,
		height: '100%',
		[theme.breakpoints.down('sm')]: {
			border: 'none',
			padding: 0,
			borderRadius: 0,
			// height: 'calc(100% - 48px)',
		},
	},
})

export default connect(
  (state) => ({
    selectedActionPrediction:
      state.tasks.addOrEdit.fields.selectedActionPrediction.value,
  }),
  null,
)(withStyles(styles)(PreviewAndFormContent))
